/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
const entity = {
  mutate(formData, structure) {
    return formData;
  },
};
export default entity;
